import { Component } from "@angular/core";
import { RouterOutlet } from "@angular/router";

@Component({
    selector: 'app-class-control-layout',
    template: `
        <router-outlet></router-outlet>
    `,
    imports: [
        RouterOutlet
    ],
})
export class ClassControlLayout {

}